// 🔹 Image source list (easy to maintain & faster)
const images = [
  "/a1.jpg",    "/a3.jpg",  "/a4.jpg",  "/a5.jpg",
  "/a6.jpg",  "/a7.jpg",  "/a8.jpg",  "/a9.jpg",  "/a10.jpg",
  "/a11.jpg", "/a12.jpg", "/a13.jpg", "/a14.jpg", "/a15.jpg",
  "/a16.jpg", "/a17.jpg", "/a18.jpg", "/a19.jpg", "/a20.jpg",
  "/a21.jpg", "/a22.jpg", "/a23.jpg", "/a24.png",
  "/d1.jpg",  "/d2.jpg",  "/d3.jpg",  "/d4.jpg",  "/d5.jpg",
  "/d6.jpg",  "/d7.jpg",  "/d8.jpg",  "/d9.jpg",  "/d10.jpg",
  "/d11.png",
];

export const COUPLES = [
  {
    slug: "ashwini-shrikant",
    title: "Ashwini & Shrikant",
    coverImage: images[20], // a6
    images: images.slice(3, 24), // a1 → a24
    quote: "Weddmac captured our day with such warmth and artistry.",
  },
  {
    slug: "nikita-partik",
    title: "Nikita & Partik",
    coverImage: images[25], // a16
    images: images.slice(25, 36), // a11 → a19
    quote: "From chaos to calm — every moment preserved beautifully.",
  },
  {
    slug: "shivangi-bhaumik",
    title: "Shivangi & Bhaumik",
    coverImage: images[20], // a21
    images: images.slice(20, 29), // a21 → a29
    quote: "More than just photos. They gave us lasting memories.",
  },
];
